export const authConfig = {
  region: process.env.REACT_APP_AWS_COGNITO_REGION,
  userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
  cookieStorage: {
    domain: process.env.REACT_APP_DOMAIN,
    expires: 365,
    // OPTIONAL - Cookie secure flag
    // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
    secure: false
  },
}

export const appSyncConfig = {
  'aws_appsync_graphqlEndpoint': process.env.REACT_APP_APPSYNC_ENDPOINT,
  'aws_appsync_region': process.env.REACT_APP_AWS_COGNITO_REGION,
  'aws_appsync_authenticationType': 'API_KEY',
  'aws_appsync_apiKey': process.env.REACT_APP_APPSYNC_KEY,
}